//
//
//
//

export default {
  name: 'box',
  props: {
    gap: String
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/box/index.vue